import { ButtonSize } from '../../../../subcomponents/button/types/size';
import { defaultFormConfig } from '../../../../subcomponents/form/form/types/config';
/**
 * Default configurations for the Member Password Reset Form component.
 */
export const defaultMemberPasswordResetFormConfig = {
    submitButton: Object.assign(Object.assign({}, defaultFormConfig.submitButton), { size: ButtonSize.Large }),
    cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false })
};
